import { useEffect, useRef } from "react";
import { useAuth as useClerkAuth, useClerk } from "@clerk/react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// After Google sign-in via Clerk, exchanges the Clerk session for the app's own login cookie.
export function ClerkBridge() {
  const { isSignedIn, getToken } = useClerkAuth();
  const { signOut } = useClerk();
  const { user, setUser, refreshNotifications } = useAuth();
  const busy = useRef(false);

  useEffect(() => {
    if (!isSignedIn || user !== false || busy.current) return;
    busy.current = true;
    (async () => {
      try {
        const { data } = await api.post("/auth/clerk-exchange", null, { headers: { Authorization: `Bearer ${await getToken()}` } });
        setUser(data);
        refreshNotifications();
        toast.success(`Bem-vindo, ${data.name?.split(" ")[0] || ""}!`);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Falha no login com Google");
        await signOut();
      } finally {
        busy.current = false;
      }
    })();
  }, [isSignedIn, user, getToken, setUser, refreshNotifications, signOut]);

  return null;
}
